import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X  } from "lucide-react";

export default function Navbar({ t, lang, setLang }) {

  const location = useLocation();
  const isHome = location.pathname === "/";

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);
  
  useEffect(() => {
    if (!isHome) return;

    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  return (
    <>
    <nav
      className={`navbar bg-custom navbar-expand-lg fixed-top navbar-dark
        ${
          isHome
            ? scrolled
              ? "navbar-visible"
              : "navbar-hidden"
            : "navbar-visible"
        }`
      }
    >
      <div className="container-fluid px-4">
        <NavLink className="navbar-brand" to="/" style={{display:'flex', flexDirection: 'row'}}>
          <img
          className="logo-nav"
          src={
            isHome
              ? scrolled
                ? "/images/logo-b.png"   // navbar-visible sur home
                : "/images/logo.png"  // navbar-hidden sur home
              : "/images/logo-b.png"     // autres pages = navbar-visible
          }
          alt="Julie Huguet" 
          style={{ maxWidth: '150px', width: '50vw', height: 'auto' }}
          />
        </NavLink>

        <button className="custom-toggler" onClick={() => setMenuOpen(true)} >
          <Menu size={32} strokeWidth={1.5} />
        </button>

        <div id="nav" className="collapse navbar-collapse">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/about">{t("nav_about").toUpperCase()}</NavLink></li>
            <li className="nav-item"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/projects">{t("nav_projects").toUpperCase()}</NavLink></li>
            <li className="nav-item"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/medias">{t("nav_medias").toUpperCase()}</NavLink></li>
            <li className="nav-item"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/agenda">{t("nav_agenda").toUpperCase()}</NavLink></li>
            <li className="nav-item"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/contact">{t("nav_contact").toUpperCase()}</NavLink></li>
            {/* Language Switch */}
            <li className="nav-item ms-lg-3 align-items-center" style={{display:'flex'}}>
              <button
                className="nav-lang btn btn-sm me-2"
                onClick={() => setLang("fr")}
                disabled={lang === "fr"}
              >
                FR
              </button>

              <button
                className="nav-lang btn btn-sm"
                onClick={() => setLang("en")}
                disabled={lang === "en"}
              >
                EN
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
      <div className={`menu-overlay ${menuOpen ? "open" : ""}`}>

        <button
          className="overlay-close"
          onClick={() => setMenuOpen(false)}
          aria-label="Fermer le menu"
        >
          <X size={32} strokeWidth={1.5} />
        </button>

        <div className="overlay-content">
          <ul className="navbar-nav ms-auto" style={{textAlign:'center'}}>
            <li className="nav-item-overlay"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/about">{t("nav_about").toUpperCase()}</NavLink></li>
            <li className="nav-item-overlay"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/projects">{t("nav_projects").toUpperCase()}</NavLink></li>
            <li className="nav-item-overlay"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/medias">{t("nav_medias").toUpperCase()}</NavLink></li>
            <li className="nav-item-overlay"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/agenda">{t("nav_agenda").toUpperCase()}</NavLink></li>
            <li className="nav-item-overlay"><NavLink className={({ isActive }) =>"nav-link" + (isActive ? " active-link" : "")} to="/contact">{t("nav_contact").toUpperCase()}</NavLink></li>
            {/* Language Switch */}
            <li className="nav-item-overlay ms-lg-3 mt-4 align-items-center" style={{display:'flex'}}>
              <button
                className="nav-lang btn btn-sm me-2"
                onClick={() => setLang("fr")}
                disabled={lang === "fr"}
              >
                FR
              </button>

              <button
                className="nav-lang btn btn-sm"
                onClick={() => setLang("en")}
                disabled={lang === "en"}
              >
                EN
              </button>
            </li>
          </ul>
        </div>
      </div>
      </>
  );
}